import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  description: () => faker.lorem.sentence(),
  identifier: () => faker.lorem.slug(),
  title: () => faker.lorem.word(),
  required: (i) => i % 2 === 0,
  position: (i) => i,
});
